import { render } from "./CookiePopup.vue?vue&type=template&id=660293f6&scoped=true"
import script from "./CookiePopup.vue?vue&type=script&lang=js"
export * from "./CookiePopup.vue?vue&type=script&lang=js"

import "./CookiePopup.vue?vue&type=style&index=0&id=660293f6&scoped=true&lang=css"

import exportComponent from "/Users/medvedevpavel/Documents/code/lb_advice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660293f6"]])

export default __exports__